const quickLinks = [
  { href: "#top", label: "首页" },
  { href: "#live", label: "实时动态" },
  { href: "#schedule", label: "赛程安排" },
  { href: "#report", label: "晋级战报" },
  { href: "#bracket", label: "晋级名单" },
  { href: "#faq", label: "常见问题" },
];

const topics = [
  { label: "小组海选赛程", href: "#schedule" },
  { label: "16 强晋级名单", href: "#bracket" },
  { label: "8 强晋级战报", href: "#report" },
  { label: "半决赛前瞻", href: "#live" },
  { label: "决赛之夜日程", href: "#schedule" },
];

export default function Footer() {
  return (
    <footer className="bg-accent-700 text-accent-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="relative flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-accent-700">
                <i className="ri-emotion-laugh-line text-xl" aria-hidden="true"></i>
                <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full border-2 border-accent-700 bg-secondary-400"></span>
              </span>
              <span className="font-heading text-2xl leading-none text-accent-50">吃瓜大赛</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-accent-100/90">
              一个把“吃瓜”做成晋级的娱乐栏目：赛程安排、晋级战报、实时动态速递一站掌握，
              追更从不迷路。本站所有瓜位与剧情均为虚构演绎，仅供娱乐。
            </p>
            <a
              href="mailto:hello@chigua-dasai.example.com"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-2 text-sm font-medium text-accent-50 transition-colors hover:bg-background-50 hover:text-accent-700"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              hello@chigua-dasai.example.com
            </a>
          </div>

          {/* quick nav */}
          <nav aria-label="页脚导航">
            <h4 className="font-heading text-base text-accent-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="inline-flex items-center gap-1.5 text-accent-100/90 transition-colors hover:text-background-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* columns */}
          <nav aria-label="栏目板块">
            <h4 className="font-heading text-base text-accent-50">栏目板块</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {topics.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="inline-flex items-center gap-1.5 text-accent-100/90 transition-colors hover:text-background-50">
                    <i className="ri-arrow-right-s-line text-accent-100/70" aria-hidden="true"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-accent-50/15 pt-6 text-xs text-accent-100/70 sm:flex-row sm:items-center">
          <p>© 2026 吃瓜大赛栏目 · 内容仅供娱乐参考</p>
          <p className="flex items-center gap-2">
            赛季 S07 实时更新中
            <span className="inline-flex items-center gap-1 rounded-full bg-background-50/10 px-2 py-0.5">
              <span className="h-1.5 w-1.5 rounded-full bg-secondary-300 chg-pulse"></span>
              进行到半决赛
            </span>
          </p>
        </div>
      </div>

      {/* back to top */}
      <a
        href="#top"
        aria-label="回到顶部"
        className="fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950/85 text-background-50 shadow-lg transition-colors hover:bg-primary-600 md:bottom-8 md:right-8"
      >
        <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
      </a>
    </footer>
  );
}